module.exports = __webpack_public_path__ + "static/favicon-6772b7a3772974f71344debdfb43912f.png";